<template>
  <div
    class="rounded-xl bg-n-solid-2 p-4 outline outline-1 outline-n-weak"
    aria-hidden="true"
  >
    <div class="flex gap-2 mb-3">
      <div class="h-10 w-10 flex-shrink-0 rounded-full bg-n-alpha-3" />
      <div class="flex-1 flex flex-col gap-1">
        <div class="h-3 w-[85%] rounded bg-n-alpha-3" />
        <div class="h-3 w-[50%] rounded bg-n-alpha-3" />
      </div>
    </div>

    <div class="flex flex-col gap-2 mb-3 pt-2 border-t border-n-weak">
      <div class="h-3 w-[70%] rounded bg-n-alpha-3" />
      <div class="h-3 w-[50%] rounded bg-n-alpha-3" />
    </div>

    <div class="flex gap-2">
      <div class="h-5 w-14 rounded-full bg-n-alpha-3" />
      <div class="h-5 w-14 rounded-full bg-n-alpha-3" />
    </div>
  </div>
</template>
